// Estado de UI do shell (Zustand). NÃO guarda dado de domínio — isso vem do catálogo (TanStack Query).
// Aqui só vive estado de interface: filtro de superfície e o log de acionamentos da sessão.
import { create } from "zustand";

// Superfície inicial pode vir do env (VITE_SURFACE_OWNER). Vazio = todas.
const ENV_SURFACE = import.meta.env.VITE_SURFACE_OWNER || undefined;

interface UiState {
  // Filtro de superfície (CONNECT_SELLER, LAI_DISK_ADMIN, …). undefined = todas.
  surfaceOwner: string | undefined;
  setSurfaceOwner: (surface: string | undefined) => void;

  // Capabilities acionadas nesta sessão (mais recente primeiro; só as habilitadas chegam aqui).
  activations: string[];
  recordActivation: (capabilityId: string) => void;
}

export const useUiStore = create<UiState>((set) => ({
  surfaceOwner: ENV_SURFACE,
  setSurfaceOwner: (surfaceOwner) => set({ surfaceOwner }),

  activations: [],
  recordActivation: (capabilityId) =>
    set((state) => ({ activations: [capabilityId, ...state.activations].slice(0, 50) })),
}));
